import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { SITE, NAV, LOGO } from "@/lib/site";
import { Reveal } from "@/components/motion";

export const Footer = () => (
  <footer className="bg-navy text-cream" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-24 pb-28 md:pb-16">
      <Reveal>
        <p className="uppercase text-[11px] tracking-[0.3em] font-bold text-gold">
          You don&rsquo;t have to do everything yourself
        </p>
        <div className="mt-6 flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-2xl">
            Let&rsquo;s talk about what
            <br />
            <em className="text-gold-light">we can take off your plate.</em>
          </h2>
          <Link
            to="/contact"
            data-testid="footer-cta-button"
            className="inline-flex w-fit items-center justify-center rounded-full bg-gold px-8 py-4 text-sm font-bold tracking-wide text-navy-dark transition-all duration-300 hover:bg-gold-light hover:-translate-y-0.5"
          >
            Get in Touch
          </Link>
        </div>
      </Reveal>

      <div className="mt-20 grid gap-12 border-t border-cream/15 pt-14 md:grid-cols-3">
        <div>
          <img
            src={LOGO}
            alt="Porter New Orleans professional organizer and personal concierge service logo"
            className="h-28 w-auto rounded-sm border border-cream/20 bg-white object-cover"
            loading="lazy"
          />
          <p className="mt-5 text-sm leading-relaxed text-cream/60">
            Professional organization &amp; personal concierge for Greater New Orleans since {SITE.founded}.
          </p>
        </div>
        <div>
          <h3 className="text-[11px] uppercase tracking-[0.28em] font-bold text-gold">Explore</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-cream/75">
            {NAV.map((item) => (
              <li key={item.to}>
                <Link to={item.to} data-testid={`footer-nav-${item.label.toLowerCase()}`} className="transition-colors hover:text-gold-light">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-[11px] uppercase tracking-[0.28em] font-bold text-gold">Follow Along</h3>
          <ul className="mt-4 space-y-3 text-sm text-cream/75">
            <li>
              <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-2 transition-colors hover:text-gold-light">
                <Instagram size={14} className="text-gold" /> @porterneworleans
              </a>
            </li>
          </ul>
          <p className="mt-6 text-xs leading-relaxed text-cream/45">
            The best way to reach Porter is through the contact form — every note is answered personally.
          </p>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-cream/15 pt-7 text-xs text-cream/45 sm:flex-row sm:items-center">
        <p>© 2026 {SITE.legalName}. All rights reserved.</p>
        <p>Serving the Greater New Orleans Area</p>
      </div>
    </div>
  </footer>
);
